export default "__VITE_ASSET__5ovYsbot__"